export default '6.47.3';